import { lazy } from 'react';
import PlatformModules from '../../../core/accessControl/Modules';
import ProtectedRoute from '../../../core/accessControl/ProtectedRoute';
import Template from '../../../core/templates/baseApp';
import { DayScheduleTemplate } from '../components/common/DayScheduleTemplate';
import DaySchedule from '../pages/DaySchedule';
import SelectSubjectsSchedule from '../pages/SelectSubjectsSchedule';
import { PAMainCard } from '../components/PlanConfig/MainCard';
import LoadingHub from '../pages/LoadingHub';

const PlanConfigPage = lazy(() => import('../pages/PlanConfig'));
const PlanConfigStartPage = lazy(() => import('../pages/PlanConfigStart'));
const WeekSchedulePage = lazy(() => import('../pages/WeekSchedule'));
const FullSchedulePage = lazy(() => import('../pages/FullSchedule'));
const ManageSchedulePage = lazy(() => import('../pages/ManageSchedule'));
const DisciplinesContentsPage = lazy(
  () => import('../pages/DisciplinesContents')
);
const ScheduleHub = lazy(() => import('../pages/ScheduleHub'));
const ScheduleSummary = lazy(() => import('../pages/ScheduleSummary'));
const ScheduleLoadingPage = lazy(() => import('../pages/LoadPage'));

const defaultModulesToAllow = [PlatformModules.NAVEGACAO_LIVRE_DISCIPLINAS.ID];

export const PlanoAdaptativoRoutes = [
  {
    path: '',
    element: (
      <ProtectedRoute
        modulesAllowed={defaultModulesToAllow}
        element={
          <Template>
            <ScheduleLoadingPage />
          </Template>
        }
      />
    ),
  },
  {
    path: ':UUID/hub',
    element: (
      <ProtectedRoute
        modulesAllowed={defaultModulesToAllow}
        element={
          <Template>
            <LoadingHub />
          </Template>
        }
      />
    ),
  },
  {
    path: 'configuracao/inicio',
    element: (
      <ProtectedRoute
        modulesAllowed={defaultModulesToAllow}
        element={
          <Template>
            <PlanConfigPage />
          </Template>
        }
      />
    ),
  },
  {
    path: ':UUID/configuracao/inicio',
    element: (
      <ProtectedRoute
        modulesAllowed={defaultModulesToAllow}
        element={
          <Template>
            <PlanConfigPage />
          </Template>
        }
      />
    ),
  },
  {
    path: ':UUID/resumo',
    element: (
      <ProtectedRoute
        modulesAllowed={defaultModulesToAllow}
        element={
          <Template>
            <PAMainCard background={''} className='flex flex-col gap-6 '>
              <ScheduleSummary />
            </PAMainCard>
          </Template>
        }
      />
    ),
  },
  // {
  //   path: 'configuracao/inicio',
  //   element: (<ProtectedRoute
  //     modulesAllowed={defaultModulesToAllow}
  //     element={<Template>
  //       <PlanConfigStartPage />
  //     </Template>}
  //   />
  //   ),
  // },
  {
    path: ':scheduleId/adicionar_assunto',
    element: (
      <ProtectedRoute
        modulesAllowed={defaultModulesToAllow}
        element={
          <Template>
            <SelectSubjectsSchedule />
          </Template>
        }
      />
    ),
  },
  {
    path: ':scheduleId/completo',
    element: (
      <ProtectedRoute
        modulesAllowed={defaultModulesToAllow}
        element={
          <Template>
            <FullSchedulePage />
          </Template>
        }
      />
    ),
  },
  {
    path: ':scheduleId/disciplinas',
    element: (
      <ProtectedRoute
        modulesAllowed={defaultModulesToAllow}
        element={
          <Template>
            <DisciplinesContentsPage />
          </Template>
        }
      />
    ),
  },
  {
    path: ':scheduleId/dia',
    element: (
      <ProtectedRoute
        modulesAllowed={defaultModulesToAllow}
        element={
          <Template>
            <DayScheduleTemplate>
              <DaySchedule />
            </DayScheduleTemplate>
          </Template>
        }
      />
    ),
  },
  {
    path: ':scheduleId/gerenciar_assuntos',
    element: (
      <ProtectedRoute
        modulesAllowed={defaultModulesToAllow}
        element={
          <Template>
            <ManageSchedulePage />
          </Template>
        }
      />
    ),
  },
];
